"use client";

import Iframe from "@/library/components/Iframes/Iframe";

export default function IframeBlock({ blok }) {
  const { iframe_url, title } = blok;

  return <Iframe iframe_url={iframe_url} title={title} />;
}
